import Div from "../../components/atoms/Div";
import LandingIntroductionBackgroundSvg from "../svgs/LandingIntroductionBackgroundSvg";

export default function LandingIntroductionBackground({fillColour}) {
	return (
		<Div position="absolute" top={'0'} left={'0'} width={'100%'} height={'100%'} zIndex={'-1'}>
			<LandingIntroductionBackgroundSvg />
		</Div>
	)
}